export default function PHP_set_error_handler() {
  return (
    <div>
      <h1>PHP_set_error_handler</h1>
    </div>
  );
}
